/**
 * Chat input store (Zustand).
 *
 * Source of truth for the chat composer's text value. Lifted out of
 * `ChatInput.tsx`'s local `useState` in T3.6 because the MCP-UI
 * `prompt` action needs to write into the same field — the user
 * decides whether to send. With the value held in component state,
 * a card-emitted prompt had no path in.
 *
 * The store is intentionally small: a single string value plus a
 * setter. It does NOT auto-submit, does NOT track focus, and does
 * NOT carry attachments — those remain in the component since the
 * card flow has no use for them.
 *
 * Multiple chat inputs would share state today; in practice the app
 * only mounts one composer at a time. If that changes, scope this
 * per-session via a Map keyed by sessionId.
 */
import { create } from 'zustand';

interface ChatInputState {
  /** Current composer text. */
  value: string;
  /** Set the composer text. Pass an empty string to clear. */
  setValue: (value: string) => void;
}

export const useChatInputStore = create<ChatInputState>((set) => ({
  value: '',
  setValue: (value) => set({ value }),
}));
